import styled from 'styled-components';

const LayoutContentWrapper = styled.div`
  padding: 16px 20px 50px 20px;
  display: flex;
  flex-flow: row wrap;
  overflow: hidden;
  
  .breadcrumbContentWrapper {
    margin-bottom: 16px;
  }

  @media only screen and (max-width: 767px) {
    padding: 16 20px 50px 20px;
  }

  @media (max-width: 575px) {
    padding: 0;
  }
`;

export { LayoutContentWrapper };
